<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="table"
      :visible.sync="modalVisible"
      :no-padding="true"
      @confirm="confirm">
    <template #header>
      <span>添加预估</span>
    </template>
    <template #content>
            <div class="add-local">
                <gj-button @click="addLocal">添加</gj-button>
            </div>
            <div>
                <gj-table
                  ref="gjTable"
                  size='has-picture'
                  name="flag"
                  :index="false"
                  :data="tableData"
                  :columns="columns"
                  :loading="loading"
                  :adapt-height="false"
                  :height="350"
                  @sort-change="$gjSortChange"
                  @page-change="$gjNoticeQuery">
                  <!-- 店铺 -->
                  <template v-slot:marketId="{ row }">
                      <div>
                        <gj-market-select
                          v-model="row.marketId"
                          init-value
                          :clearable="false"
                          width="130px"
                          @input="$gjNoticeQuery"
                      ></gj-market-select>
                      </div>
                  </template>
                  <!-- 缺货时间 -->
                  <template v-slot:lackGoodDate="{ row }">
                    <div>{{ row.lackGoodDate || '-' }}</div>
                  </template>
                  <!-- 缺货天数 -->
                  <template v-slot:lackGoodDay="{ row }">
                    <div v-if="row.lackGoodDay || row.lackGoodDay === 0">
                        <el-popover trigger="hover"
                            placement="left"
                            width="200">
                            <div slot="reference" style="cursor: pointer;">{{ row.lackGoodDay }}天 <i class="el-icon-arrow-down"></i></div>
                            <div class="both-sides pb">
                                <span>缺货开始时间</span>
                                <span>{{ row.lackGoodDate }}</span>
                            </div>
                            <div class="both-sides">
                                <span>缺货结束时间</span>
                                <span>{{ row.lackGoodDateEnd }}</span>
                            </div>
                        </el-popover>
                    </div>
                    <div v-else>-</div>
                  </template>
                  <!-- 下单日期 -->
                  <template v-slot:underOrderDate="{ row }">
                    <el-date-picker
                      v-model="row.underOrderDate"
                      type="date"
                      size="small"
                      :clearable="false"
                      @change="change(row)"
                      placeholder="选择日期">
                    </el-date-picker>
                  </template>
                  <!-- 补货数量 -->
                  <template v-slot:makeGoodQuantity="{ row }">
                    <gj-input
                        maxlength="8"
                        v-checkInteger:makeGoodQuantity="{value: row.makeGoodQuantity, obj: row}"
                        v-model="row.makeGoodQuantity"
                        width="100%"
                        placeholder="请输入"
                    ></gj-input>
                  </template>
                  <!-- 物流方式 -->
                  <template v-slot:transportId="{ row }">
                    <gj-select
                        :options="transportOption"
                        v-model="row.transportIdPrescriptionId"
                        width="140px"
                        @change="change(row)"
                        :clearable="false"
                    ></gj-select>
                  </template>
                  <!-- 预计入库时间 -->
                  <template v-slot:expectInboundDate="{ row }">
                    <el-date-picker
                      v-model="row.expectInboundDate"
                      type="date"
                      size="small"
                      :clearable="false"
                      placeholder="选择日期"
                      :class="{'date-expect': compareDate(row)}">
                    </el-date-picker>
                  </template>
                  <!--操作  -->
                  <template v-slot:op="{ index }">
                      <gj-button type="text" @click="deleteItem(index)">删除</gj-button>
                  </template>
                </gj-table>
            </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import { storageAnalysisAddEstimate } from "@/api/statistics";
  import { convertToDate } from "@/utils/date.util.js"
  export default {
    name: "app-child-product-add-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      tabList: {
        type: Array,
        default: () => []
      },
      transportOption: {
        type: Array,
        default: () => []
      },
      pageParams: {
          type: Object,
          default: () => ({})
      },
      dataZoomMap: {
          type: Object,
          default: () => ({})
      },
      storageAnalysisGetSmart: {
        type: Object,
        default: () => ({})
      }
    },
    directives: {
        // 控制只能输入整数
        checkInteger: {
            update: (el, binding) => {
                let params = binding.value
                const regexp = (/[^0-9]|^0+(?!$)/g);
                if (!params || !params.value) { return }
                if (regexp.test(params.value)) {
                    params.obj[binding.arg] = params.value.replace(regexp, "");
                }
            }
        }
    },
    created() {
        this.Splicing()
    },
    data() {
      return {
        tableData: [],
        columns: [
            // id: 字段ID，用于优化渲染以及自定义列，必填
            // header: 表头名称结构为：v-slot:header:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
            // field: 字段内容域，类型为数据字段名或slot
            // help: 帮助信息（问号）
            // notCustomColumn: 是否是自定义字段，默认：false
            // default: 是否自定义列默认字段
            {id: 'marketId', header: '店铺', field: 'slot:marketId', minWidth: '140px', default: true},
            {id: 'lackGoodDate', header: '缺货时间', field: 'slot:lackGoodDate', minWidth: '80px', default: true, disabled: true},
            {id: 'lackGoodDay', header: '缺货天数', field: 'slot:lackGoodDay', minWidth: '80px', default: true, disabled: true},
            {id: 'underOrderDate', header: '下单日期', field: 'slot:underOrderDate', minWidth: '140px', default: true},
            {id: 'makeGoodQuantity', header: '补货数量', field: 'slot:makeGoodQuantity', minWidth: '140px', default: true},
            {id: 'transportId', header: '物流方式', field: 'slot:transportId', minWidth: '140px', default: true},
            {id: 'expectInboundDate', header: '预计入库时间', field: 'slot:expectInboundDate', minWidth: '140px', default: true},
            {id: 'op', header: '操作', field: 'slot:op', width: '70px', notCustomColumn: true},
        ],
        loading: false,
      }
    },
    methods: {
        compareDate(row) {
          if (row.lackGoodDate && row.lackGoodDate && convertToDate(row.expectInboundDate) > convertToDate(row.lackGoodDate)) {
            return true
          }
          return false
        },
        // 拼接补货数据
        Splicing() {
            let flag = true //false: 上一个时间库存是0；true：上一个库存不是0
            let tabList = []
            for (const iterator of this.tabList) {
                // 当前是库存为0且上一个库存不是0
                if (iterator.fullFillAbleQuantity <= 0 && flag) {
                    tabList.push({
                        expectInboundDate: "", // 预计入库日期
                        lackGoodDate: iterator.smartDate, // 缺货开始日期
                        lackGoodDateEnd: iterator.smartDate, // 缺货结束日期
                        lackGoodDay: 1, // 缺货天数
                        makeGoodQuantity: Math.ceil(iterator.expectConsumeQuantity), // 补货数量
                        marketId: "", // 店铺ID
                        transportIdPrescriptionId: "",
                        underOrderDate: new Date(), // 下单日期
                    })
                }
                // 当前库存为0且上一个库存也是0
                if (iterator.fullFillAbleQuantity <= 0 && !flag) {
                    tabList[tabList.length - 1].lackGoodDay++
                    tabList[tabList.length - 1].makeGoodQuantity += Math.ceil(iterator.expectConsumeQuantity)
                    tabList[tabList.length - 1].lackGoodDateEnd = iterator.smartDate
                }
                iterator.fullFillAbleQuantity == 0 ? flag = false : flag = true
            }
            // 处理选取
            for (const iterator of tabList) {
              if (iterator.lackGoodDateEnd > this.dataZoomMap.endValue && iterator.lackGoodDate > this.dataZoomMap.endValue) {
                iterator.lackGoodDateEnd = iterator.lackGoodDate
                iterator.lackGoodDay = 0
                iterator.makeGoodQuantity = 0
              }
              if (iterator.lackGoodDateEnd > this.dataZoomMap.endValue && iterator.lackGoodDate <= this.dataZoomMap.endValue) {
                iterator.lackGoodDateEnd = this.dataZoomMap.endValue
                iterator.lackGoodDay = (new Date(this.dataZoomMap.endValue).getTime() - new Date(iterator.lackGoodDate).getTime())/86400000
                iterator.makeGoodQuantity = Math.ceil(iterator.lackGoodDay * Number(this.storageAnalysisGetSmart.consumeQuantity))// 补货数量
              }
            }
            // todo 处理补货数量
            this.tableData = tabList
        },
        // 静态添加预估
        addLocal() {
            this.tableData.push({
              expectInboundDate: "", // 预计入库日期
              lackGoodDate: "", // 缺货日期
              lackGoodDay: "", // 缺货天数
              makeGoodQuantity: "", // 补货数量
              marketId: "", // 店铺ID
              transportIdPrescriptionId: "",
              underOrderDate: new Date(), // 下单日期
            })
        },
        // 静态删除
        deleteItem(index) {
            this.tableData.splice(index, 1);
        },
        // 确定
        confirm() {
            if (!this.perfectData) {
                this.$gjMessage.error('请完善预估数据');
                // 在slot中加样式
                return;
            }
            this.storageAnalysisAddEstimate()
        },
        // 添加预估
        async storageAnalysisAddEstimate() {
            let res = await storageAnalysisAddEstimate(this.structureParams())
            this.$emit("storageAnalysisListEstimate")
            this.$gjDestroy();

        },
        // 构造添加预估params
        structureParams() {
            let params = {
                asinCode: this.pageParams.asinCode, //ASIN类型值
                asinType: this.pageParams.asinType, //ASIN类型（子asin：child，父asin：parent）
                addList: []
            }
            params.addList = this.tableData.reduce((arr, item) => {
                let split = item.transportIdPrescriptionId.split("#")
                let elment = {
                    expectInboundDate: convertToDate(item.expectInboundDate),
                    lackGoodDate: item.lackGoodDate,
                    lackGoodDay: item.lackGoodDay,
                    makeGoodQuantity: item.makeGoodQuantity,
                    marketId: item.marketId,
                    prescriptionId: split[1],
                    transportId: split[0],
                    underOrderDate: convertToDate(item.underOrderDate)
                }
                arr.push(elment)
                return arr
            }, [])
            return params
        },
        // 改变预计入库日期
        change(row) {
          // this.storageAnalysisGetSmart
          // 下单日期起算 + 物流天数 + 采购交期 + 安全库存天数
          let logisticsDays = 0
          for (const iterator of this.transportOption) {
            if (row.transportIdPrescriptionId == iterator.id) {
              logisticsDays = iterator.text.split("-")[1]
              logisticsDays = logisticsDays.substr(0,logisticsDays.length-1)
            }
          }
          let day = Number(logisticsDays) + Number(this.storageAnalysisGetSmart.purchaseDeliveryDays)
          let time = 86400000*day
          let time1 = new Date(row.underOrderDate).getTime()
          row.expectInboundDate = convertToDate(time + time1)
        }
    },
    computed: {
        // 判断table数据是否完善
        perfectData() {
            if (!this.tableData || this.tableData.length == 0) {
                return false
            }
            for (const iterator of this.tableData) {
                if(
                    !iterator.expectInboundDate ||
                    !iterator.makeGoodQuantity ||
                    !iterator.marketId ||
                    !iterator.transportIdPrescriptionId ||
                    !iterator.underOrderDate
                ) {
                    return false
                }
            }
            return true
        }
    }
  }
</script>

<style scoped lang="scss">
.both-sides {
    font-size: 12px;
    color: #888;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.pb {
      padding-bottom: 3px;
    }
}
/deep/.date-expect {
  .el-input__inner {
      color: #F56C6C;
      border-color: #fbc4c4;
  }
}
  /deep/.el-input {
    width: 100%;
  }
  .add-local {
      display: flex;
      justify-content: flex-end;
      padding: 15px 15px 0 0;
  }
  .add-product-btn {
      margin: 5px 0 10px;
  }
</style>
